// @mui material components
import {
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  Card,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Grid,
  Icon,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  //   TableContainer,
  //   Paper,
  //   ListItem,
  //   ListItemText,
  //   Divider,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
// import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import MDBadge from "theme/components/MDBadge";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useEffect, useState } from "react";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

function BillingPage() {
  const pageTitle = `Account Billing`;
  usePageTitle(pageTitle);

  function emptyCache() {
    if ("caches" in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
  }

  function versionRefresh() {
    emptyCache();
    window.location.reload();
  }

  function appVersionCheck(newVersion) {
    // Handle App Update
    const currentVersion = localStorage.getItem(AppConfig.app_version_store);
    let shouldUpdate = false;
    if (currentVersion !== newVersion) {
      shouldUpdate = true;
    }
    localStorage.setItem(AppConfig.app_version_store, newVersion);

    if (shouldUpdate) {
      if (
        window.confirm(
          "A new version is available. App will automatically refresh to get the latest update."
        ) === true
      ) {
        versionRefresh();
      } else {
        versionRefresh();
      }
    }
  }

  const [refreshPage, setRefreshPage] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [currency, setCurrency] = useState(null);
  const [plan, setPlan] = useState(null);
  const [fees, setFees] = useState([]);
  const [data, setData] = useState({});

  const [subscriptionPaymentDuration, setSubscriptionPaymentDuration] = useState(null);
  const [openSubscriptionPaymenttDialog, setOpenSubscriptionPaymenttDialog] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/billing.json`)
        .then((result) => {
          setShowLoading(false);
          console.log(result);
          if (result.data.status === "success") {
            setCurrency(result.data.data.currency);
            setPlan(result.data.data.plan);
            setFees(result.data.data.fees);
            setData(result.data.data);
          } else {
            setErrMsg(result.data.data.message);
            setSeverity("error");
            setOpen(true);
          }

          appVersionCheck(result.data.version);
        })
        .catch(() => {
          setShowLoading(false);
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setSeverity("error");
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function paySubscription() {
    if (subscriptionPaymentDuration == null || subscriptionPaymentDuration <= 0) {
      setSeverity("error");
      setErrMsg("Please select a duration");
      setOpen(true);
      return;
    }

    if (window.confirm(`Proceed with payment?`) === false) {
      return;
    }

    setOpenSubscriptionPaymenttDialog(false);
    setShowLoading(true);
    const json = {
      duration: subscriptionPaymentDuration,
    };

    await axios
      .post("portal/license/subscription/pay.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openSubscriptionPaymenttDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Subscription Payment</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={1}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Duration</InputLabel>
                <Select
                  label="Duration"
                  onChange={(e) => {
                    setSubscriptionPaymentDuration(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="1">1 Month</MenuItem>
                  <MenuItem value="3">3 Months</MenuItem>
                  <MenuItem value="6">6 Months</MenuItem>
                  <MenuItem value="12">12 Months</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenSubscriptionPaymenttDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="contained"
            onClick={() => {
              paySubscription();
            }}
          >
            Pay Now
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox mt={3} mb={5}>
        {plan ? (
          <MDBox>
            <MDBox>
              <Card>
                <MDBox p={2}>
                  <MDTypography variant="body2">Plan</MDTypography>
                  <MDTypography variant="h6">{plan.title}</MDTypography>
                </MDBox>
              </Card>
            </MDBox>
            {plan.code !== "PAG" && (
              <MDBox mt={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox align="right">
                      <Card sx={{ width: "100%", minHeight: "220px" }}>
                        <MDBox p={1} align="center">
                          <MDBox>
                            <Icon color="warning" fontSize="large">
                              support_agent
                            </Icon>
                          </MDBox>
                          <MDTypography variant="h6" fontWeight="regular">
                            Monthly License Plan
                          </MDTypography>
                          {data.license ? (
                            <MDBox mt={1}>
                              <MDTypography variant="h6" fontWeight="light">
                                Cover (Agents):{" "}
                                <b>
                                  {data.license.license.cover.toLocaleString("en-US", {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  })}
                                </b>
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="light">
                                Fee / Agent:{" "}
                                <b>
                                  {`${currency}${(data.license.license.fee / 100).toLocaleString(
                                    "en-US",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}`}
                                </b>
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="light">
                                Fee / Agent (extra):{" "}
                                <b>
                                  {`${currency}${(
                                    data.license.license.additional_fee / 100
                                  ).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}`}
                                </b>
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="light" mb={2.5}>
                                Sales Cap:{" "}
                                <b>
                                  {data.license.license.sales_cap > 0
                                    ? data.license.license.sales_cap.toLocaleString("en-US", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                      })
                                    : "UNLIMITED"}
                                </b>
                              </MDTypography>
                            </MDBox>
                          ) : (
                            <MDBox mt={1}>
                              <MDTypography variant="h6" fontWeight="light">
                                You have no active plan found.
                              </MDTypography>
                              <MDBox mt={5}>
                                <MDButton
                                  size="small"
                                  variant="outlined"
                                  color="info"
                                  onClick={() => {}}
                                >
                                  <Icon sx={{ fontWeight: "bold" }}>send</Icon>
                                  &nbsp;Subscribe
                                </MDButton>
                              </MDBox>
                            </MDBox>
                          )}
                        </MDBox>
                      </Card>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox align="right">
                      <Card sx={{ width: "100%", minHeight: "220px" }}>
                        <MDBox p={1} align="center">
                          <MDBox>
                            <Icon color="info" fontSize="large">
                              receipt
                            </Icon>
                          </MDBox>
                          <MDTypography variant="h6" fontWeight="regular">
                            Subscription
                          </MDTypography>
                          {data.license?.subscription ? (
                            <MDBox>
                              <MDTypography variant="h6" fontWeight="light">
                                <MDBadge
                                  badgeContent="ACTIVE"
                                  variant="contained"
                                  container
                                  color="success"
                                />
                              </MDTypography>
                              <MDBox mt={1}>
                                <MDTypography variant="h6" fontWeight="light">
                                  Expires On
                                  <br />
                                  <b>{data.license.subscription.expires_on}</b>
                                </MDTypography>
                              </MDBox>
                            </MDBox>
                          ) : (
                            <MDBox mb={3}>
                              <MDTypography variant="h6" fontWeight="light">
                                No active subscription. Pay now to activate your plan.
                              </MDTypography>
                            </MDBox>
                          )}
                          <MDBox mt={1} mb={0.5}>
                            <MDButton
                              size="small"
                              variant="outlined"
                              color="info"
                              onClick={() => {
                                setSubscriptionPaymentDuration(null);
                                setOpenSubscriptionPaymenttDialog(true);
                              }}
                            >
                              <Icon sx={{ fontWeight: "bold" }}>send</Icon>
                              &nbsp;Pay Now
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
            )}
            <MDBox mt={3}>
              <Card>
                <MDBox p={0}>
                  <MDBox p={2}>
                    <MDTypography variant="h6" fontWeight="medium">
                      Fees
                    </MDTypography>
                  </MDBox>
                  <MDBox>
                    <Table aria-label="campaign information">
                      <TableBody>
                        {fees.map((fee) => (
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="light">
                                {fee.title}
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              {fee.is_percentage ? (
                                <MDBox>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    {`${(fee.fee * 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}%`}
                                  </MDTypography>
                                  {fee.minimum > 0 && (
                                    <MDTypography variant="h6" fontWeight="light" fontSize={12}>
                                      {`Minimum: ${currency}${(fee.minimum / 100).toLocaleString(
                                        "en",
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )}`}
                                    </MDTypography>
                                  )}
                                </MDBox>
                              ) : (
                                <MDTypography variant="h6" fontWeight="regular">
                                  {`${currency}${(fee.fee / 100).toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}`}
                                </MDTypography>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </MDBox>
                  <MDBox mt={5} p={2}>
                    <Alert severity="warning">
                      <b>IMPORTANT!</b> All fees are charged to your Laddar wallet. To avoid service
                      distruption, keep your wallet sufficiently funded.
                    </Alert>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        ) : (
          <> </>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default BillingPage;
